var _defs, _polygon, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _polygon2, _path2, _path3, _path4, _path5, _g0, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaintingFacade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-5);}.cls-6{clip-path:url(#clippath-3);}.cls-7{clip-path:url(#clippath-4);}.cls-8{clip-path:url(#clippath-2);}.cls-9{clip-path:url(#clippath-1);}.cls-12{fill:#683a3d;}.cls-13{fill:#f07662;}.cls-14{fill:#e7f3f8;}.cls-15,.cls-16{fill:#fff;}.cls-17{fill:#ffe5b8;}.cls-18{fill:#ffd588;}.cls-19{fill:#e5ce8b;}.cls-20{fill:#fcd385;}.cls-21{fill:#efefef;}.cls-22{fill:#fcdea3;}.cls-23{fill:#914147;}.cls-24{fill:#b3b3b3;}.cls-25{fill:#c6e3e7;}.cls-26{fill:#c9a86a;}.cls-27{fill:#cfcfcf;}.cls-28{fill:#c7dbf2;}.cls-10{mask:url(#mask);}.cls-16{fill-rule:evenodd;}.cls-11{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "22.95 0 88.88 33.6 82.18 80.14 14.96 46.43 14.96 3.63 22.95 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.96 3.63 82.18 37.34 82.18 82.67 14.96 48.97 14.96 3.63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.18 77.75 82.18 86.42 14.96 52.71 14.96 44.04 82.18 77.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.13,35.17l13.8,6.9v17.35l-13.8-6.9v-17.35Zm-2.56-4.34v23.85l18.92,9.46v-23.85l-18.92-9.46Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.41 29.26 55.57 30.83 55.57 54.49 52.41 56.66 52.41 29.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.57 54.49 55.57 54.49 74.49 63.95 74.49 67.69 52.41 56.85 52.41 56.66 55.57 54.49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.13 52.52 71.93 59.41 71.93 42.07 58.13 35.17 58.13 52.52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.54 34.97 59.12 35.76 59.12 51.92 57.54 53.11 57.54 34.97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.12 51.92 59.12 51.92 71.93 58.23 71.93 60.2 57.54 53.11 59.12 51.92"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 14.99,
    y: 74.17,
    width: 35.99,
    height: 20.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    className: "cls-16",
    points: "14.99 74.17 50.98 74.17 50.98 95.08 14.99 95.08 14.99 74.17"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "22.95 0 88.88 33.6 82.18 80.14 14.96 46.43 14.96 3.63 22.95 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 5.11,
    y: -8.76,
    width: 86.92,
    height: 98.75
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m76.5,89.88l12.38-6.83c1.72-1.01-21.55-16.48-21.55-16.48,0,0,15.33-28.86,14.51-28.38l-26.63-12.8L10.28,52.24c-1.7,1-1.72,3.45-.04,4.49l63.55,33.12c.83.51,1.87.52,2.7.03Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 5.11,
    y: -6.22,
    width: 86.92,
    height: 98.75
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 5.11,
    y: 34.18,
    width: 86.92,
    height: 62.09
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 45.71,
    y: 20.98,
    width: 38.63,
    height: 53.02
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 42.56,
    y: 19.4,
    width: 22.86,
    height: 47.11
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 42.56,
    y: 44.63,
    width: 41.79,
    height: 32.92
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 48.28,
    y: 25.32,
    width: 33.51,
    height: 43.96
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 47.68,
    y: 25.12,
    width: 21.29,
    height: 37.84
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 47.68,
    y: 42.07,
    width: 34.1,
    height: 27.99
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "14.96 52.57 14.96 3.63 28.26 10.3 28.26 29.33 40.23 35.53 40.23 65.38 14.96 52.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-23",
    d: "m34.48,28.35l-2,12.08c-.12.59.26,1.16.85,1.28.59.12,1.16-.26,1.28-.85l2-12.08c.12-.59-.26-1.16-.85-1.28-.59-.12-1.16.26-1.28.85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-12",
    d: "m34.55,28.18c.12-.59.69-.97,1.28-.85.59.12.97.69.85,1.28-.12.59-.69.97-1.28.85s-.97-.69-.85-1.28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-13",
    d: "m29.13,15.54c-.56.92-.51,1.98.12,2.36l14.03,6.69c.63.38,1.59-.06,2.15-.99.56-.93.51-1.98-.12-2.36l-14.03-6.69c-.63-.38-1.59.06-2.15.99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-24",
    d: "m34.89,27.74l.89-4.01s.34-.69,1.06-.44c.72.26,7.68,3.86,7.68,3.86,0,0,.6.22.87-.57.27-.79.81-1.92.81-1.92l-1.61-.71s-.6-.29-.48-.72c.12-.43.54-.5.54-.5l2.68,1.06s.7.51.03,1.77c-.68,1.26-1.29,2.56-1.29,2.56,0,0-.67.99-2.05.23-1.38-.76-6.84-3.48-6.84-3.48l-.82,3.47-1.48-.6Z"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Axa.be-Fixico-_-Homecare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    className: "cls-12",
    points: "29.04 75.32 17.18 82.29 36.87 93.98 49.08 87.01 29.04 75.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    className: "cls-12",
    points: "29.1 75.32 29.1 77.8 36.88 82.29 38.66 87.01 43.82 90.02 49.08 87.01 29.1 75.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7",
    className: "cls-12",
    points: "36.87 82.29 26.73 87.96 19.18 83.48 29.1 77.8 36.87 82.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    className: "cls-20",
    points: "49.66 90.18 49.66 92.63 36.67 100 36.67 97.32 49.66 90.18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    className: "cls-22",
    points: "50.98 87.01 29.1 74.17 14.99 82.29 36.87 95.08 50.98 87.01"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    className: "cls-14",
    points: "29.04 75.32 17.18 82.29 36.87 93.98 49.08 87.01 29.04 75.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-11",
    className: "cls-28",
    points: "29.1 75.32 29.1 77.8 36.88 82.29 38.66 87.01 43.82 90.02 49.08 87.01 29.1 75.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-12",
    className: "cls-14",
    points: "36.87 82.29 26.73 87.96 19.18 83.48 29.1 77.8 36.87 82.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-13",
    className: "cls-28",
    points: "29.1 77.8 23.34 81.07 36.88 82.29 29.1 77.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-14",
    className: "cls-22",
    points: "36.87 97.44 50.98 89.43 50.98 87.01 36.87 95.08 36.87 97.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-15",
    className: "cls-19",
    points: "14.99 82.29 36.87 95.08 36.87 97.44 14.99 84.88 14.99 82.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    className: "cls-13",
    d: "m30.44,90.18s.13-.67.59-.32c.46.35.6.66.98.58.37-.09.14-1.12.14-1.12l-.49-1.84s-.06-.83.56,0l1.28,1.3s.66.64.72,0c.06-.64,0-1.45,0-1.45,0,0,.17-.71.81-.23,0,0,.63,1.21,1.18.95.55-.26.29-1.04.29-1.04l-.63-2.16s-.14-1.07.46-.49c.6.58,1.18,2.19,1.18,2.19,0,0,.72.91,1.18.77.46-.14.49-.68.49-.68v-1.35s-.63-1.09-.26-1.27c.37-.17,1.21.81,1.21.81l1.64,2.19s.66,1.24,1.07.6c.4-.63.52-.6.52-.6,0,0-.03,1.61.26,1.9.29.29.59.89.59.89l-7.26,4.28-6.5-3.9h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-17",
    className: "cls-26",
    points: "16.4 85.69 36.67 97.32 36.67 100 16.4 88.25 16.4 85.69"
  }))))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "88.87 82.67 82.18 86.42 82.18 37.34 88.88 33.6 88.87 82.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintingFacade);
export default __webpack_public_path__ + "static/media/painting-facade.cbc08d7dbfbe9958bed22cf3829b541d.svg";
export { ForwardRef as ReactComponent };